/**
 * Feedback client — POST feedback to relay server.
 * Uses same relay URL pattern as relayHttp.ts.
 */

export interface FeedbackPayload {
  category: 'bug' | 'feature' | 'pricing-wrong' | 'ux-friction';
  severity: 'critical' | 'annoying' | 'suggestion';
  text: string;
  route: string;
  sport?: string;
  marketType?: string;
  buildHash?: string;
  viewport?: string;
  connectionStatus?: string;
  timestamp: string;
}

const envRelayUrl = (import.meta.env.VITE_RELAY_HTTP_URL as string | undefined)?.trim();
const BASE_URL =
  envRelayUrl && envRelayUrl.length > 0
    ? envRelayUrl.replace(/\/relay\/http$/, '')
    : import.meta.env.DEV
      ? 'http://localhost:8787'
      : '';

export async function submitFeedback(payload: FeedbackPayload): Promise<{ ok: boolean }> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(`${BASE_URL}/relay/feedback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Feedback submit failed: ${response.status}`);
    }
    return { ok: true };
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
}
